import React, { Suspense, lazy } from 'react';
import { Hero } from './components/sections/Hero';
import { ImpactStats } from './components/sections/ImpactStats';
import { SocialProof } from './components/sections/SocialProof';
import { Pain } from './components/sections/Pain';
import { MidCTA } from './components/sections/MidCTA';
import { MetaPixel } from './components/MetaPixel';
// Lazy load below-fold sections to speed up initial render
const ProductIntro = lazy(() => import('./components/sections/ProductIntro').then(m => ({
  default: m.ProductIntro
})));
const Tomos = lazy(() => import('./components/sections/Tomos').then(m => ({
  default: m.Tomos
})));
const Bonus = lazy(() => import('./components/sections/Bonus').then(m => ({
  default: m.Bonus
})));
const PricingSection = lazy(() => import('./components/sections/PricingSection').then(m => ({
  default: m.PricingSection
})));
const Comparison = lazy(() => import('./components/sections/Comparison').then(m => ({
  default: m.Comparison
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/sections/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
const SectionFallback = () => <div className="py-20" aria-hidden="true" data-id="element-0" data-mp="38nupxslbeg0n" />;
export function App() {
  return <div className="min-h-screen font-sans bg-hueso text-oscuro selection:bg-terracota/30" data-id="element-1" data-mp="3dm5z013scmht">
      <MetaPixel data-id="element-2" data-mp="nv0xxsp64o55" />
      <Hero data-id="element-3" data-mp="nxn4pq48izmb" />
      <ImpactStats data-id="element-4" data-mp="suncc5gqgafj" />
      <SocialProof data-id="element-5" data-mp="su44xiopl4fr" />
      <Pain data-id="element-6" data-mp="stko65asom3b" />
      <MidCTA data-id="element-7" data-mp="stccggqermtp" />

      <Suspense fallback={<SectionFallback data-id="element-9" data-mp="swgm3tmn7arr" />} data-id="element-8" data-mp="sssskuh76od1">
        <ProductIntro data-id="element-10" data-mp="35yngfn0fdzc" />
        <Tomos data-id="element-11" data-mp="356sn718lka4" />
        <Bonus data-id="element-12" data-mp="34nabp7octvk" />
        <PricingSection id="precios" data-id="element-13" data-mp="38ktuby5znfz" />
        <Comparison data-id="element-14" data-mp="3udazkg91d18e" />
        <Testimonials data-id="element-15" data-mp="3ubzso7kandd2" />
        <Guarantee data-id="element-16" data-mp="3ucjehzd2elwd" />
        <FAQ data-id="element-17" data-mp="3uf5m1yzyh1el" />
        <Footer data-id="element-18" data-mp="d4e4fpsbp6v4" />
        <PurchasePopup data-id="element-19" data-mp="d4xopd5g47cb" />
      </Suspense>
    </div>;
}